import { RemoveDeviceFromOrganisationQueryArg } from '../types/query-arg';
import { RemoveDeviceFromOrganisationQueryBody } from '../types/query-body';

export const removeDeviceFromOrganisationQueryBody = ({
  device: { endpointId },
}: RemoveDeviceFromOrganisationQueryArg): RemoveDeviceFromOrganisationQueryBody => ({
  actionType: 'RemoveOrganisation',
  endpointId,
});
